export class LkpBanksModel{
bnkcode ='';
bnkname ='';
bnknotes ='';
bnkaccount ='';
bnkopenbalance =0;
bnkcurrency ='';
bnkrate =0;
bankopentype ='';
bnkDefult = false;
compcode = '1';
userid ='sa';
modifieddate = '2022-01-01';
}
